import React from 'react';
import { ResponsiveModal } from 'components/Modals/ResponsiveModal';
import { Button } from 'components/form/Button';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import './filterModal.scss';

const FilterModal = props => {
  const {
    showModal,
    onCancelFilter,
    children,
    onApplyFilter,
    isApplyFilterDisabled,
    showResetButton,
    onResetFilter,
  } = props;

  return (
    <ResponsiveModal
      visible={showModal}
      wrapClassName="filter-modal-wrapper"
      width="390px"
      onCancel={onCancelFilter}
      headerTitle={'Filters'}
      ariaLabel="Filter Model"
      headerButton={
        showResetButton && (
          <Button className="reset" mrphType="link" onClick={onResetFilter}>
            Reset
          </Button>
        )
      }
      isHeaderTitleAlwaysShown
      footer={
        <FlexContainer className="padLR8 m-padLR0">
          <Button
            mrphType="standard"
            onClick={props.onCancelFilter}
            className="m-margR12"
            fullWidth
          >
            Cancel
          </Button>
          <Button
            mrphType="primary"
            onClick={onApplyFilter}
            className="m-margL12"
            fullWidth
            disabled={isApplyFilterDisabled}
          >
            Apply
          </Button>
        </FlexContainer>
      }
    >
      {children}
    </ResponsiveModal>
  );
};

export default FilterModal;
